module.exports = __webpack_public_path__ + "img/counter_woman.e2cda51b.svg";